import i18n from "i18n";

export const accountsMessages = {
  update: i18n.t('notifications.accounts.update'),
  disable: i18n.t('notifications.accounts.disable'),
  enable: i18n.t('notifications.accounts.enable')
}
